
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...contentSlug]",
      function () {
        return require("private-next-pages/[...contentSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...contentSlug]"])
      });
    }
  